import {
  LayoutDashboard,
  Users,
  BarChart3,
  TrendingUp,
  Briefcase,
  Calendar,
  ShieldCheck,
  BadgeDollarSign,
  GitBranch,
  Brain,
  Activity,
  Target,
  Building2,
  UserCog,
  Sparkles,
  Search,
} from 'lucide-react';

export const getWorkforceIntelNavChildren = () => [
  {
    label: 'Workforce Visibility, Structure & Health',
    icon: Activity,
    children: [
      { path: '/workforce-intelligence/dashboard', label: 'Workforce Dashboard', icon: LayoutDashboard },
      { path: '/workforce-intelligence/master-visibility', label: 'Workforce Master Visibility', icon: Users },
      { path: '/workforce-intelligence/headcount', label: 'Headcount Intelligence', icon: BarChart3 },
      { path: '/workforce-intelligence/demographics', label: 'Demographic Intelligence', icon: BarChart3 },
      { path: '/workforce-intelligence/status-movement', label: 'Workforce Status & Movement', icon: TrendingUp },
      { path: '/workforce-intelligence/skills-capability', label: 'Skills & Capability Visibility', icon: Briefcase },
      { path: '/workforce-intelligence/availability-utilization', label: 'Availability & Utilization', icon: Activity },
      { path: '/workforce-intelligence/attendance-leave-workpatterns', label: 'Attendance, Leave & Work Patterns', icon: Calendar },
      { path: '/workforce-intelligence/performance-productivity', label: 'Performance & Productivity', icon: BarChart3 },
      { path: '/workforce-intelligence/engagement-experience', label: 'Engagement signals (workforce ops)', icon: Activity },
      { path: '/workforce-intelligence/compliance-documents-policy', label: 'Compliance, Documents & Policy', icon: ShieldCheck },
      { path: '/workforce-intelligence/cost-compensation', label: 'Compensation & labor cost visibility (WFI)', icon: BadgeDollarSign },
    ],
  },
  {
    label: 'Workforce Optimization, Planning & Decision Support',
    icon: Target,
    children: [
      { path: '/workforce-intelligence/workforce-planning', label: 'Workforce Planning', icon: Target },
      { path: '/workforce-intelligence/demand-supply', label: 'Demand vs Supply', icon: BarChart3 },
      { path: '/workforce-intelligence/resource-optimization', label: 'Resource Optimization', icon: TrendingUp },
      { path: '/workforce-intelligence/capacity-planning', label: 'Capacity Planning', icon: Activity },
      { path: '/workforce-intelligence/mobility-movement', label: 'Mobility & Movement Planning', icon: GitBranch },
      { path: '/workforce-intelligence/career-progression', label: 'Career & Progression Intelligence', icon: TrendingUp },
      { path: '/workforce-intelligence/learning-capability', label: 'Learning & Capability Development', icon: Briefcase },
      { path: '/workforce-intelligence/succession-continuity', label: 'Succession & Continuity', icon: Users },
      { path: '/workforce-intelligence/retention-stability', label: 'Retention & Stability', icon: Activity },
      { path: '/workforce-intelligence/cost-optimization', label: 'Workforce cost levers (planning)', icon: BadgeDollarSign },
      { path: '/workforce-intelligence/org-design', label: 'Organization Design Intelligence', icon: Building2 },
      { path: '/workforce-intelligence/manager-effectiveness', label: 'Manager Effectiveness Intelligence', icon: UserCog },
      { path: '/workforce-intelligence/experience-decision-support', label: 'Workforce experience planning (ops)', icon: Activity },
      { path: '/workforce-intelligence/scenario-modeling', label: 'Scenario Modeling & What-if Planning', icon: Sparkles },
    ],
  },
  {
    label: 'Predictive Intelligence, Risk & Strategic Foresight',
    icon: Brain,
    children: [
      { path: '/workforce-intelligence/forecasting', label: 'Workforce Forecasting', icon: TrendingUp },
      { path: '/workforce-intelligence/attrition-flight-risk', label: 'Attrition & Flight Risk Prediction', icon: Activity },
      { path: '/workforce-intelligence/burnout-wellbeing-risk', label: 'Burnout & Wellbeing Risk Prediction', icon: Activity },
      { path: '/workforce-intelligence/skill-risk-capability-gap', label: 'Skill Risk & Capability Gap Prediction', icon: Briefcase },
      { path: '/workforce-intelligence/productivity-performance-risk', label: 'Productivity & Performance Risk Prediction', icon: BarChart3 },
      { path: '/workforce-intelligence/cost-risk-budget', label: 'Cost risk & budget signals (WFI)', icon: BadgeDollarSign },
      { path: '/workforce-intelligence/compliance-audit-risk', label: 'Compliance & Audit Risk Prediction', icon: ShieldCheck },
      { path: '/workforce-intelligence/ai-recommendations', label: 'AI-Powered Workforce Recommendations', icon: Brain },
      { path: '/workforce-intelligence/ai-copilot', label: 'Workforce Copilot (WFI)', icon: Search },
      { path: '/workforce-intelligence/strategic-risk-intelligence', label: 'Strategic Workforce Risk Intelligence', icon: Brain },
      { path: '/workforce-intelligence/strategic-opportunity-intelligence', label: 'Strategic Workforce Opportunity Intelligence', icon: Brain },
      { path: '/workforce-intelligence/executive-intelligence', label: 'Executive Decision Intelligence', icon: LayoutDashboard },
    ],
  },
  {
    label: 'Legacy',
    icon: GitBranch,
    children: [
      { path: '/workforce-intelligence/legacy-demand-supply', label: 'Demand-Supply Forecast (Legacy)', icon: GitBranch },
      { path: '/workforce-inventory', label: 'Workforce Skills Inventory (Legacy)', icon: Briefcase },
      { path: '/resource-optimization', label: 'Resource Optimization (Legacy)', icon: TrendingUp },
    ],
  },
];

